import { create } from 'zustand';

const useAppStore = create((set) => ({
  app: '',
  setApp: (payload) => set({ app: payload }),
  basePath: '',
  setBasePath: (payload) => set({ basePath: payload }),
  nextModule: false,
  setNextModule: (payload) => set({ nextModule: payload }),
  distributor: {},
  setDistributor: (payload) => set({ distributor: payload }),
  globalAction: {},
  setGlobalAction: (payload) => set({ globalAction: payload }),
}));

export default useAppStore;
